import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';

export const isTemplateListSupported = (country: DeclarationCountry, internalType: DeclarationInternalType) => {
    const isIrelandTemplate =
        country === DeclarationCountry.IRELAND &&
        (internalType === DeclarationInternalType.IMPORT ||
            internalType === DeclarationInternalType.ENS ||
            internalType === DeclarationInternalType.EXPORT ||
            internalType === DeclarationInternalType.NCTS);
    const isUkTemplate =
        country === DeclarationCountry.UK &&
        (internalType === DeclarationInternalType.EXPORT ||
            internalType === DeclarationInternalType.IMPORT ||
            internalType === DeclarationInternalType.NCTS);
    const isEuTemplate = country === DeclarationCountry.EU && internalType === DeclarationInternalType.ENS;

    return isIrelandTemplate || isUkTemplate || isEuTemplate;
};
